<a (click)="navigateBackwards()" class="btn btn-outline-secondary">
  <i class="fas fa-arrow-left"></i>
  <span class="pl-1" translate>PREVIOUS_PAGE</span>
</a>
